var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout-btn thinly-shadowed",on:{"click":_vm.logout}},[_c('img',{staticClass:"logout-img",attrs:{"src":require("@/assets/img/utils/logout.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }